import { render } from "./AddCurrentPositionToUserLocationDialog.vue?vue&type=template&id=8d5d2330&scoped=true&ts=true"
import script from "./AddCurrentPositionToUserLocationDialog.vue?vue&type=script&lang=ts"
export * from "./AddCurrentPositionToUserLocationDialog.vue?vue&type=script&lang=ts"

import "./AddCurrentPositionToUserLocationDialog.vue?vue&type=style&index=0&id=8d5d2330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5d2330"]])

export default __exports__